import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [ 'csvisible','openGroup' ];

    connect() {
        super.connect();
        this.form = this.element;
        this.updateCsVisibles();

        this.groupstate = new Set();

        if( this.form.__groupstate.value ) {
            var grstates = this.form.__groupstate.value.split(',');
            for( var i=0; i<grstates.length; i++) {
                this.groupToggle({params: {groupName: grstates[i]}});
            }
        }

        this.openGroupTargets.forEach( (group) => {
           group.click();
        });
    }

    // this is called BEFORE connect since it are children that are added
    csvisibleTargetConnected( target ) {
        this.log("connect csvisibleTarget", [target]);
    }

    disconnect() {
        super.disconnect();
    }

    fieldValue( fieldname ) {
        var elements = document.getElementsByName( fieldname );
        if( elements.length ) {
            var values = new Array;
            for ( var i=0; i<elements.length; i++) {
                var el = elements[i];
                if( el.type == 'radio' || el.type == 'checkbox' ) {
                    if( el.checked ) {
                        values.push( el.value );
                    }
                } else {
                    values.push( el.value );
                }
            }
            return values.join(',');
        } else {
            alert('Runtime Error fieldValue '+fieldname);
        }
    }

    updateCsVisibles( event ) {
        this.log("updateCsVisibles");
        this.csvisibleTargets.forEach( (target) => {
            this.log("check ",[target, target.dataset.csvisible]);
            {
                var values = (name) => {
                    this.log('values',[name]);
                    return this.fieldValue(name);
                }

                var visible = eval(target.dataset.csvisible);

                if( visible ) {
                    this.log('visible')
                    target.style.display = '';
                } else {
                    this.log('not visible')
                    target.style.display = 'none';
                }
            }

            if( event )
                this.form.__changed.value = 1;
        });

        var el = this.form.querySelector('#changed');
        if( el ) {
            if( this.form.__changed.value == 1) {
                el.style.display = "";
            } else {
                el.style.display = "none";
            }
        }

    }

    submit({ params: { action, confirm } }) {
        this.log("submit", [action,confirm]);
        if( confirm ) {
            if( ! window.confirm(confirm) ) {
                return;
            }
        }
        this.form.__action.value = action;
        this.form.__groupstate.value = this.groupstate.values().toArray().join(',');
        // this.form.__tabstate.value = tabstate.toString();
        this.form.submit();
    }

    groupToggle( { params: { groupName }}) {
        var entries = this.form.querySelector("#groupentries_"+groupName);
        var state = -1;
        if( entries ) {
            if( entries.style.display != "none" ) {
                entries.style.display = "none";
                state = 0;
            } else {
                entries.style.display = "";
                state = 1;
            }

            if( state ) {
                this.groupstate.add(groupName);
            } else {
                this.groupstate.delete(groupName);
            }

            /*
            label points to a  that contains a TD that has the IMG
            somewhere
            */
            var label = this.form.querySelector("#grouplabel_"+groupName);
            if( label != null ) {
                // first image in this tr is the one that is switched
                var img = label.querySelector('IMG');

                if( img ) {
                    if( state ) {
                        // expanded
                        img.src= image_path+"/"+expanded_fold_image;
                    } else {
                        // collapsed
                        img.src= image_path+"/"+collapsed_fold_image;
                    }
                }
            }
        }

    }
}
